export default __webpack_public_path__ + "static/media/ne.c9e3235f.jpg";